import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=008676a3&scoped=true&"
import script from "./SecondaryButton.vue?vue&type=script&lang=js&"
export * from "./SecondaryButton.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=008676a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008676a3",
  null
  
)

component.options.__file = "SecondaryButton.vue"
export default component.exports